import type { PersonalBoard } from '@tasks/contracts';

import { apiRequest } from './client';

export type PersonalBoardParams = {
  readonly q?: string;
  readonly limitPerColumn?: number;
};

/** Персональная доска «Мои задачи» по всем проектам (docs/05 §6a). */
export function getPersonalBoard(
  params: PersonalBoardParams = {},
  signal?: AbortSignal,
): Promise<PersonalBoard> {
  return apiRequest<PersonalBoard>('/my/board', {
    query: { q: params.q, limitPerColumn: params.limitPerColumn },
    signal,
  });
}
